import React, {useEffect, useMemo, useState} from 'react';
import VStack from "../../../../../../common/Layout/VStack";
import SimpleInput from "../../../../../../common/SimpleInput";
import {t} from "../../../../../../../services/i18n";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {GlobalConsts} from "../../../../../../../styles/GlobalConsts";
import {Colors} from "../../../../../../../styles/Colors";
import CustomButtonV2 from "../../../../../../common/CustomButtonV2";
import {getBoxSettingProperties, isMobile} from "../../../../../../../services/Helpers";
import {HStack} from "native-base";
import {useDispatch, useSelector} from "react-redux";
import AppText from "../../../../../../common/AppText";
import orderBy from 'lodash-es/orderBy';
import DropDownMenu from "../../../../../../common/DropDownMenu";
import {fetchApi} from "../../../../../../../services/HTTP";
import {getScheduleCancelReasons} from "../../../../../../../redux/boxSlice";
import {useToast} from "react-native-toast-notifications";
import {openModal, SETTINGS_VALUE_MODAL} from "../../../../../../../redux/modalManagerSlice";
import {CANCEL_REASONS} from "../../../../../../../Configs/SettingsValueModalOptions";

const ScheduleCancelReason = (props) => {
    const { } = props;
    const scheduleCancelReasons = useSelector(state => state.box.box?.scheduleCancelReasons);
    const [searchValue, setSearchValue] = useState('');
    const [filteredData, setFilteredData] = useState(null);
    const [currStatus, setCurrStatus] = useState('active');
    const statusOptions = useMemo(() => [{id: 'active', name: t('active')}, {id: 'inactive', name: t('inactive')}], []);
    const dispatch = useDispatch()
    const toast = useToast()

    useEffect(() => {
        if(scheduleCancelReasons && currStatus) {
            handleSearch()
        }
    }, [scheduleCancelReasons, searchValue, currStatus]);

    const handleSearch = () => {
        const data = orderBy(scheduleCancelReasons, [item => item.name.toLowerCase()], ['asc']).filter(reason => reason.active === (currStatus === 'active' ? 1 : 0))
        if(searchValue.length >= 1) {
            const filtered = data.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase()));
            setFilteredData(filtered);
        }
        else {
            setFilteredData(data);
        }
    }

    const openCreateEditCancelReason = (target = {}) => {
        dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: CANCEL_REASONS, initialValue: {...target, val: target.name, default: getBoxSettingProperties('defaults')?.schedule_cancel_reason_id === target.id, scope: 'schedule'}, params: target }}))
    }

    const deleteOrRestoreCancelReason = async (target) => {
        try {
            const route = target.active ? 'deleteBoxCancelReason' : 'restoreBoxCancelReason'
            await fetchApi(route, 'post', {reason_id: target.id, scope: 'schedule'}, false, true);
            dispatch(getScheduleCancelReasons())
        } catch(error) {
            toast.show(t('cancel-reason-status-update-failed'), { type: 'danger', duration: 2000 });
        }
    }

    return (
        <VStack>
            <HStack alignItems={'center'} justifyContent={'space-between'} space={'5px'}>
                <SimpleInput
                    placeholder={t('search')}
                    prefix={<FontAwesomeIcon icon={light('magnifying-glass')} fontSize={GlobalConsts.iconSize.XS} color={Colors.newDesign.darkGrey}/>}
                    value={searchValue}
                    onChangeCallback={setSearchValue}
                />
                <DropDownMenu title={t(currStatus)}
                              items={statusOptions}
                              onPress={setCurrStatus}
                              width={'8rem'}
                              showBorder={true}
                />
                <CustomButtonV2 wrapperStyle={{width: isMobile && '25%' }} type={'primary'} text={t('create')} onClick={() => openCreateEditCancelReason()} />
            </HStack>
            <div style={{ maxHeight: '380px', marginTop: '10px' }}>
                {
                    filteredData?.map((reason) => (
                        <HStack key={`schedule_cancel_reason_${reason.id}`} alignItems={'center'} style={{ cursor: 'pointer' ,paddingTop: '15px', paddingBottom: '15px', borderBottom: 'solid 1px ' + Colors.newDesign.mediumGrey }}>
                            <AppText onClick={() => openCreateEditCancelReason(reason)} style={{ flexGrow: 1 }}>{reason.name}</AppText>
                            <CustomButtonV2 type={'link'} tooltipText={t(`${reason.active ? 'delete' : 'restore'}-schedule-cancel-reason`)} iconName={`fa-trash${!reason.active ? '-undo' : ''}`} onClick={() => deleteOrRestoreCancelReason(reason)} style={{ paddingInlineEnd: '5px' }} />
                        </HStack>
                    ))
                }
            </div>
        </VStack>
    );
};

export default ScheduleCancelReason;